const requestQuote = {
  hero: {
    title: "Kostenlose Beratung buchen",
    description:
      "Füllen Sie das Formular aus – unser Team meldet sich so schnell wie möglich, um die Details zu bestätigen.",
  },
  form: {
    title: "Anfrageformular",
  },
  call: {
    prefix: "Sie möchten lieber anrufen?",
  },
};

export default requestQuote;

